module.exports = __webpack_public_path__ + "img/4-0-0.4684e57e.png";